import "./Home.css";
import image from "./image.jpg";

const Home = () => {
  return (
    <div className="home_container">
      <div className="welcome_text_container">
        <h1>Herzlich Wilkommen bei C'est&nbsp;la&nbsp;vie!</h1>
        <h2>... die Live-Musik-Band für Ihr Fest</h2>
        <h2>
          <b>NEU mit Sängerin Steffi – mega Stimme!</b>
        </h2>
      </div>
      <div className="image_container">
        <img src={image} className="img-fluid" alt="2 der 3 Mitglieder der Band vor ihrem Equipment"/>
      </div>
      <div className="bottom_text_container">
        <p>
          Professionell und langjährig erfahren sorgen wir für musikalische
          Unterhaltung, Tanzmusik und Partystimmung bei:
        </p>

        <p>
          <b>
            Hochzeit, Polterabend, Geburtstag, Fest, Party, Gala, Kirwa,
            Fasching, Tanz, Silvester, Firmenfeier, Einweihungen, etc.
          </b>
        </p>
        <p>
          Unter <a href="/samples">H&ouml;rproben</a> finden Sie ein paar kurze
          Ausschnitte von unseren Auftritten.
        </p>

        <p>
          Sie wollen wissen, ob wir an Ihrem Wunschtermin noch verf&uuml;gbar
          sind? Nehmen Sie doch einfach <a href="/contact">Kontakt</a> mit uns
          auf. Wir werden uns so schnell wie möglich mit Ihnen in Verbindung
          setzen.
        </p>
      </div>
      <div style={{ height: "1px" }} />
    </div>
  );
};

export default Home;
